import React__default from 'react';
import { Typography, Button } from '@sravni/react-design-system';
import { ACTION_BUTTON_TEXT } from '../../constants/components.js';
import modules_77a29656 from '../../reviews-action-block.module.scss.js';

const ActionButton = ({ link, handleClickActionButton }) => (React__default.createElement(Typography.Link, { className: modules_77a29656.link, href: link, onClick: handleClickActionButton },
    React__default.createElement(Button, { className: modules_77a29656.btn, color: "dark", size: 52, variant: "primary", block: true }, ACTION_BUTTON_TEXT)));

export { ActionButton };
//# sourceMappingURL=index.js.map
